import {resources} from "../../../../../../../core/models/resource/resources";

export const createComponentModalName: string = 'createComponentModal';
export const createComponentModalTitle: string = 'Создание компонента';

export const componentResourceType = resources['components'];
